module.exports = __webpack_public_path__ + "static/media/c9.98f2da9d.jpg";